export const WATCHER_ID_STORAGE_KEY = 'watcher_id';
export const CAPTURING_STATUS_STORAGE_KEY = 'capturing_status';
export const LATEST_LOCATION_STORAGE_KEY = 'latest_location';
